<template>
  <div id="heard-about-xm" class="pt-1">
    <h3 class="mt-4">How did you hear about XMission?</h3>
    <div class="form-row align-items-top">
      <div class="col-auto">
        <label class="mr-sm-2 sr-only" for="hdyh-select">Preference</label>
        <select class="custom-select mr-sm-2" id="hdyh-select" v-model="attribution">
          <option v-for="attribution_type in attribution_types" :key="attribution_type.id" :value="attribution_type.id"> {{ attribution_type.label }}</option>
        </select>
      </div>
      <input id="hdyh-other" type="text" class="ml-2" placeholder="please specify" v-if="isOtherAttribution" v-model="other_text"/>
      <button id="hdyh-skip" class="btn btn-outline-secondary ml-2" v-if="isNullAttribution" @click="skipClicked">skip</button>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      attribution: 0,
      attribution_types: [{value: '', label: '-- select --', id: 0},
                          {value: 'Postal mail', label: 'Postal mail', id: 1},
                          {value: 'Search engine', label: 'Search engine', id: 2},
                          {value: 'Social media', label: 'Social media', id: 3},
                          {value: 'Word of mouth', label: 'Word of mouth', id: 4},
                          {value: 'Radio', label: 'Radio', id: 5},
                          {value: 'News coverage', label: 'News coverage', id: 6},
                          {value: 'Event', label: 'Event', id: 7},
                          {value: 'Other', label: 'Other', id: 8}],
      other_text: '',
    }
  },

  computed : {
    isNullAttribution () {
      return this.attribution === 0;
    },
    isOtherAttribution () {
      if (this.isNullAttribution) {
        return false;
      }
      return this.attribution === 8;
    },
    formData () {
      let attribution_type = this.attribution_types.filter((x) => x.id === this.attribution)[0].value;
      if (this.isOtherAttribution && this.other_text) {
        return `${attribution_type}: ${this.other_text}`;
      }
      return attribution_type;
    }
  },

  methods: {
    skipClicked () {
      this.$emit('skip-clicked');
    }
  },

  watch : {
    formData (new_val) {
      this.$emit('input', new_val);
    }
  }
}

</script>

<style scoped>
/* how did you hear */


#hdyh-other {
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
}

.speed-radio:checked+.package {
  border:1px solid black;
  color:#444;
  box-shadow:0 2px 15px rgba(0,0,0,0.2);
  opacity:1.0;
}

.custom-select {
  background: none !important;
}

</style>



// WEBPACK FOOTER //
// AttributionDropdown.vue?5f7372b2